import React from 'react';
import NavigationMobile from './NavigationMobile';
import NavigationDesktop from './NavigationDesktop';
import type { NavigationProps } from './types';

const Navigation: React.FC<NavigationProps> = (props) => {
  return (
    <>
      {/* Mobile Navigation - Show on screens < 1024px */}
      <div className="lg:hidden">
        <NavigationMobile {...props} />
      </div>
      
      {/* Desktop Navigation - Show on screens >= 1024px */}
      <div className="hidden lg:block">
        <NavigationDesktop {...props} />
      </div>
    </>
  );
};

export default Navigation;
